"use client"
import {
  useSearchTrigger
} from "@/hooks/Header/useSearchTrigger"
import React from "react"

const SearchTrigger = React.forwardRef((props, ref) => {
  const {
    isSearchOpen, onClick 
  } = props

  const talonProps = useSearchTrigger({
    onClick,
  })
  const {
    handleClick 
  } = talonProps

  return (
    <button
      onClick={handleClick}
      ref={ref}
      className='group flex items-center gap-x-1.5'
      type='button'
      aria-label='toggle search panel'
    >
      <span className='flex h-5 w-5 items-center justify-center'>
        {isSearchOpen ? (
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='16'
            height='16'
            fill='none'
            viewBox='0 0 16 16'
          >
            <path
              className='stroke-#403732 lg_group-hover_stroke-80583F'
              strokeLinecap='round'
              strokeLinejoin='round'
              strokeWidth='1.5'
              d='M15 15L1 1m14 0L1 15'
            />
            <path
              stroke='#000'
              strokeLinecap='round'
              strokeLinejoin='round'
              strokeOpacity='0.2'
              strokeWidth='1.5'
              d='M15 15L1 1m14 0L1 15'
            />
          </svg>
        ) : (
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='20'
            height='21'
            fill='none'
            viewBox='0 0 20 21'
          >
            <path
              fillRule='evenodd'
              className='fill-#403732 lg_group-hover_fill-80583F'
              d='M9.139 17.955c2.247 0 4.27-.899 5.692-2.397 1.424-1.423 2.398-3.446 2.398-5.693 0-2.247-.9-4.27-2.398-5.693-1.423-1.423-3.445-2.397-5.692-2.397-2.248 0-4.27.9-5.693 2.397-1.424 1.423-2.397 3.446-2.397 5.693 0 2.247.899 4.27 2.397 5.693 1.423 1.498 3.445 2.397 5.693 2.397zm6.816-2.022L20 19.977l-.75.75-4.044-4.045c-1.648 1.423-3.745 2.322-6.067 2.322-2.547 0-4.794-1.049-6.442-2.697C1.049 14.66 0 12.337 0 9.865c0-2.547 1.049-4.794 2.697-6.442C4.345 1.775 6.667.727 9.139.727c2.546 0 4.794 1.048 6.442 2.696 1.647 1.648 2.696 3.97 2.696 6.442a9.105 9.105 0 01-2.322 6.068z'
              clipRule='evenodd'
            />
            <path
              fill='#000'
              fillOpacity='0.2'
              fillRule='evenodd'
              d='M9.139 17.955c2.247 0 4.27-.899 5.692-2.397 1.424-1.423 2.398-3.446 2.398-5.693 0-2.247-.9-4.27-2.398-5.693-1.423-1.423-3.445-2.397-5.692-2.397-2.248 0-4.27.9-5.693 2.397-1.424 1.423-2.397 3.446-2.397 5.693 0 2.247.899 4.27 2.397 5.693 1.423 1.498 3.445 2.397 5.693 2.397zm6.816-2.022L20 19.977l-.75.75-4.044-4.045c-1.648 1.423-3.745 2.322-6.067 2.322-2.547 0-4.794-1.049-6.442-2.697C1.049 14.66 0 12.337 0 9.865c0-2.547 1.049-4.794 2.697-6.442C4.345 1.775 6.667.727 9.139.727c2.546 0 4.794 1.048 6.442 2.696 1.647 1.648 2.696 3.97 2.696 6.442a9.105 9.105 0 01-2.322 6.068z'
              clipRule='evenodd'
            />
          </svg>
        )}
      </span>
      <span className='lg_inline lg_group-hover_text-80583F hidden text-sm leading-5'>Search</span>
    </button>
  )
})

export default SearchTrigger
